import React, { useState } from "react";
import "./css/loggin.css";
import { FiEye } from "react-icons/fi";
import { BsFillPersonFill } from "react-icons/bs";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./Body";
import Validation from "./Validation";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./FireBaseConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { doc, addDoc, setDoc } from "firebase/firestore";
import { motion } from "framer-motion";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";

const Login = () => {
  const [errors, setErrors] = useState({});

  let navigate = useNavigate();

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const { email, password } = values;

  const SaveData = async (user) => {
    console.log(user);
    try {
      let res = await setDoc(doc(db, "users", user.uid), {
        email: user.email,
      });
      navigate("/signUpPhase2");
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSingUp = async (e) => {
    e.preventDefault();
    if (email !== "" && password !== "") {
      try {
        let user = await createUserWithEmailAndPassword(auth, email, password);
        console.log(user);
        await SaveData(user.user);
        navigate("/SignUp");
      } catch (error) {
        console.log(error);
        toast.error(error.code.split("/")[1]);
      }
    } else if (email == "" || password == "") {
      let errorMessage = Validation({ email, password });
      // console.log(email,password);
      errorMessage.email && toast.error(errorMessage.email);
      errorMessage.password && toast.error(errorMessage.password);
    }
  };

  const handleGoogle = async () => {
    let google_provider = new GoogleAuthProvider();
    console.log("hlo");
    try {
      let user = await signInWithPopup(auth, google_provider);
      navigate("/SignUp");
      console.log(user);
    } catch (error) {
      console.log(error);
    }
  };

  const handlelogin = async (e) => {
    e.preventDefault();
    if (email !== "" && password !== "") {
      try {
        let user = await signInWithEmailAndPassword(auth, email, password);
        console.log(user);

        SaveData(user);
        navigate("/Dashboard");
      } catch (error) {
        console.log(error.code);
        if (error.code)
          return toast.error(error.code, {
            position: "top-center",
          });
      }
    } else if (email == "" || password == "") {
      let errorMessage = Validation({ email, password });
      errorMessage.email && toast.error(errorMessage.email);
      errorMessage.password && toast.error(errorMessage.password);
    }
  };

  // const MotionBody = motion.custom(Body);

  return (
    <>
      <Navbar icon={true} />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-5 ">
              <motion.div
                className="main-form mt-5"
                animate={{
                  // x: 100,
                  // y: 0,
                  // rotate: 0,
                  scale: 1,
                }}
                initial={{ scale: 0.6 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <div>
                  <img
                    src="/images/formimg.png"
                    alt="Form Image Not Found"
                    className="FormImg "
                  />
                  <div className="Info text-white">
                    <h3 className=" text-white">RAFFLE MANIA</h3>
                    <p>welcome to Raffle Mania One place To Shop Everythings</p>
                    <form
                      className="formInputs "
                      // onSubmit={handleFormSubmitt()}
                    >
                      <label for="email">USERNAME</label>
                      <div
                        className="form-group d-flex"
                        isInvalid={errors.email}
                      >
                        <input
                          required
                          // {...register("email")}
                          type="email"
                          className=""
                          name="email"
                          value={values.email}
                          placeholder="Enter Email"
                          id="email"
                          onChange={handleChange}
                        />

                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                      <p className="text-danger">
                        {errors.email && errors.email.message}
                      </p>
                      {errors.email && (
                        <p className=" text-danger error">{errors.email}</p>
                      )}
                      <label for="pwd">PASSWORD</label>
                      <div
                        className="form-group d-flex"
                        isInvalid={errors.password}
                      >
                        <input
                          required
                          // {...register("password")}
                          type="password"
                          className=""
                          name="password"
                          value={values.password}
                          placeholder="Enter password"
                          id="pwd"
                          onChange={handleChange}
                        />

                        <div class="input-group-append">
                          <span class="input-group-text">
                            <FiEye />
                          </span>
                        </div>
                      </div>
                      <p className="text-danger">
                        {errors.password && errors.password.message}
                      </p>
                      {errors.email && (
                        <p className="text-danger error">{errors.password}</p>
                      )}
                      <a
                        onClick={() => {
                          navigate(`/ForgotPass`);
                        }}
                        className="text-primary forgotpss"
                      >
                        Forget Password
                      </a>
                    </form>
                  </div>
                </div>
                <div className="mt-5 btnDiv p-2 pl-1 pt-4 ">
                  <button
                    className="btn  w-100 mb-1 loginBtn"
                    onClick={handlelogin}
                  >
                    Login
                  </button>
                  <button
                    className="btn  w-100 mb-1 loginBtn"
                    onClick={handleGoogle}
                  >
                    Login With Google
                  </button>
                  <button
                    className="btn w-100 mt-2 signBtn"
                    onClick={handleSingUp}
                    // onClick={() => navigate("/SignUpp")}
                  >
                    Sign Up
                  </button>
                  <p className="text-white p-3">
                    Don't Have an Account ?
                    <span className="text-primary">
                      <a>Sign Up</a>
                    </span>
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* <ToastContainer/> */}
      <Footer />
    </>
  );
};

export default Login;
